import { render, staticRenderFns } from "./TableBlueButtonEvents.vue?vue&type=template&id=5deb9070&scoped=true&"
import script from "./TableBlueButtonEvents.vue?vue&type=script&lang=js&"
export * from "./TableBlueButtonEvents.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueButtonEvents.vue?vue&type=style&index=0&id=5deb9070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb9070",
  null
  
)

export default component.exports